/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {ServiceDrivenFieldViewer} from "./ServiceDrivenFieldViewer";
import {service as ConservationActionService} from "../../../Services/ConservationActionService";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";
import React, {useState} from "react";
import {useEffectPromise} from "../../../Hooks/EffectHooks";

const _ConservationActionLinkFieldViewer = ServiceDrivenFieldViewer(ConservationActionService);

export const ConservationActionLinkFieldViewer = (props) => {
	const {
		Value,
		Data,
		RootData,
		loadingLabel = "Loading...",
		nullDisplayLabel = "N/A",
	} = props;

	const conservationActionId = Value ?? Data?.conservationActionId;
	const conservationActionPermit = RootData?.ConservationActionPermits?.[0];

	if (!conservationActionPermit || !conservationActionId) {
		return 'N/A';
	}

	const loadModel = async (value) => {
		try {
			const data = await ConservationActionService.FindById(value);
			return data?.result ?? null;
		} catch (e) {
			console.log('loadModel failed for value:', value, e);
		}
		return null;
	}
	
	const [conservationAction, setConservationAction] = useState(undefined);
	
	useEffectPromise(
		async () => loadModel(conservationActionId),
		(result) => {
			setConservationAction(result);
		},
		[conservationActionId],
		true
	);
	
	if (conservationAction === undefined) {
		return loadingLabel;
	}
	
	if (!conservationAction) {
		return nullDisplayLabel;
	}

	return <StreamBankLink className="sb-actionable-link" Href={conservationAction?.ContextNodeDetails?.link + '/permit'}>
		<_ConservationActionLinkFieldViewer
			{...props}
			Value={conservationActionId}
		/>
	</StreamBankLink>;
}
